var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.031C26.531 40.031 28.969 39.281 31.031 38.062L11.906 18.937C10.687 21 10.031 23.437 10.031 25.968C10.031 33.749 16.219 40.031 24 40.031ZM6.00002 7.96899L41.531 43.5L39 46.031L33.937 40.968C31.031 42.843 27.656 43.968 23.999 43.968C14.061 43.968 5.99902 35.905 5.99902 25.968C5.99902 22.312 7.12402 18.843 8.99902 16.03L3.46802 10.499L6.00002 7.96899ZM22.031 18.844V16.031H25.969V22.875L22.031 18.844ZM30 1.96899V5.99999H18V1.96899H30ZM38.063 9.09399L40.876 11.907L38.063 14.813C40.501 17.907 42.001 21.751 42.001 25.969C42.001 29.625 40.876 33.094 39.001 35.907L36.095 33.001C37.314 30.938 37.97 28.501 37.97 25.97C37.97 18.189 31.782 12.001 24.001 12.001C21.47 12.001 19.126 12.657 17.063 13.876L14.063 10.97C16.876 9.09499 20.344 7.96999 24.001 7.96999C28.22 7.96999 32.157 9.46999 35.251 11.908L38.063 9.09399Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerOff);
export default __webpack_public_path__ + "static/media/timer_off.dac63c16b222e377785af0180d2387be.svg";
export { ForwardRef as ReactComponent };